module.exports = __webpack_public_path__ + "img/mgh-kyoto-kawaramachi-jokyoji.bc1fd184.jpg";